module.exports = __webpack_public_path__ + "img/bubbles - transparent.2864b2e2.png";